module.exports = __webpack_public_path__ + "static/media/PDF_56.2fc92c71.pdf";